module.exports = __webpack_public_path__ + "static/media/bg_reset.ecb710dd.svg";